import { useCallback, useEffect } from 'react';
import { useConfig } from '@browsing/config';
import { trackViewItemList } from '../events';
export const useTrackViewItemList = ({ items, payload, itemMapper, triggerCondition, onTrack, }) => {
    const config = useConfig();
    const track = useCallback(() => {
        if (config.isEnabled('ga4')) {
            if (onTrack) {
                onTrack();
            }
            trackViewItemList({
                element: payload.element,
                itemListName: payload.item_list_name,
                items,
            }, {
                customMapper: itemMapper,
            });
        }
        // eslint-disable-next-line
    }, [config, items]);
    useEffect(() => {
        if (triggerCondition) {
            track();
        }
        // eslint-disable-next-line
    }, [config, track, triggerCondition]);
    return track;
};
